import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useDashboardQuery } from "../../../../api/dataWranglerApiSlice";
import { selectRunning, selectSummary } from "../../dataWranglerSlice";
import AutoModeIcon from '@mui/icons-material/AutoMode';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { colours } from "../../../../StyleConstants";
import { selectSelectedDatabase } from '../../../common/databaseSlice';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const ReportChip = () => {
    const selectedDatabase = useSelector(selectSelectedDatabase);
    const {
        data,
        isFetching
    } = useDashboardQuery({ database: selectedDatabase });
    const isSummaryRunning = useSelector(selectRunning);
    const summary = useSelector(selectSummary);
    const reportData = Object.keys(summary || {}).length > 0 ? summary : data;

    const options = {
        plugins: {
            tooltip: {
                mode: 'index',
                intersect: true,
                callbacks: {
                    footer: (tooltipItems: any[]) => {
                        let sum = 0;

                        tooltipItems.forEach((tooltipItem: any) => {
                            sum += tooltipItem.parsed.y;
                        });
                        return 'Total: ' + sum;
                    }
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const chartData: any = {
        labels: [],
        datasets: []
    };

    if (!isFetching && reportData && reportData.data) {
        const sexes = ["Female", "Male", "Unknown"];
        const sexColors: any = {
            "Female": colours.categorical.one,
            "Male": colours.categorical.two,
            "Unknown": colours.categorical.three,
        };
        chartData.labels = reportData.data.map((bar: any) => bar.name);

        chartData.datasets = sexes.map(sex => ({
            label: sex,
            data: [],
            backgroundColor: sexColors[sex],
        }));

        reportData.data.forEach((bar: any) => {
            sexes.forEach((sex, i) => {
                const count = bar.sexSummary?.[sex] ?? 0;
                chartData.datasets[i].data.push(count);
            });
        });
    }

    return (
        <Stack flexDirection="column" height="100%" gap={2} position={"relative"}>
            <LoadingOverlay show={isSummaryRunning.active}/>
            <Typography fontSize="18px" fontWeight={600}>
                Tabulated Data Selection:
            </Typography>
            {!isFetching &&
              <>
                  <Typography fontSize="14px">
                      <span id="query-wizard-unique-participants-count" style={{ fontWeight: 600 }}>{reportData?.total || 0}</span> Unique Participants
                  </Typography>
                  <Stack
                      justifyContent="center"
                      alignItems="center"
                      flexGrow={1}
                  >
                      {/* @ts-ignore */}
                      <Bar options={options} data={chartData}/>
                  </Stack>
              </>
            }
        </Stack>
    )
}

const LoadingOverlay = ({ show }: { show: boolean }) => {
    return (
        show ?
            <Stack
                flexDirection={"row"}
                gap={3}
                position="absolute"
                top={"50%"}
                justifyContent='center'
                alignItems='center'
                padding={3}
                borderRadius={2}
                sx={{
                    backgroundColor: "#E5F6FD",
                }}
            >
                <AutoModeIcon sx={{ color: "#0288D1",
                    animationName: "spin",
                    animationDuration: "1000ms",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear" }}/>
                <Typography fontWeight={"bold"} color={"#014361"}>Processing Query...</Typography>
            </Stack>
            : <></>
    )
}

export default ReportChip;